namespace RS.ExternalHelp
{
    export class ClientVersionPlugin extends RS.ExternalHelp.VisitorPlugin
    {
        private _clientVersion: string;

        public constructor(page: RS.ExternalHelp.IPage)
        {
            super(page);
            this._clientVersion = RS.URL.getParameter("clientVersion");
        }

        public onElementLoaded(element: HTMLElement)
        {
            const eID = element.id;
            if (eID == "rs-clientVersion")
            {
                element.innerHTML = element.innerHTML.replace("{gameVersion}", this._clientVersion);
            }
        }
    }
    RS.ExternalHelp.pluginRegistry.register(ClientVersionPlugin);
}